if (window.innerWidth < 480) {
  var flkty = new Flickity('.grid-masonary', {
      cellAlign: 'center', // Adjust the options for mobile
      groupCells: true,
      wrapAround: true,
      pageDots: false // You can change this option as needed
    });
  
  var flk = new Flickity('.custom-content.f-ais', {
      cellAlign: 'center', // Adjust the options for mobile
      groupCells: true,
      wrapAround: true,
      pageDots: false // You can change this option as needed
    });
}


// by nitin jamdhade on 23 jan 2024 
let  productData ;
  
let product_template_var;
$(document).ready(function(){
  if($(".ptContainer").length){
    product_template_var = $(".ptContainer").attr("data-section-id");
    productData = JSON.parse($("#ProductJson-"+product_template_var).text()); 
    
  $('.swatchInput:checked').siblings('.swatchLbl').trigger('click'); 
}
});

    $(".submitregistrationform").on("click",function(event) {
      // Prevent the form from submitting
      event.preventDefault();
      $(".error-messages").remove();
       $(".input--error").removeClass("input--error");
      // Validate inputs
      var firstName = $("#RegisterForm-firstName").val().trim();
      var email = $("#RegisterForm-email").val().trim();
      var password = $("#RegisterForm-password").val();
      var errorMessages = [];
      console.log(firstName);
      // Check if UserName is empty
      if (firstName === "") {
        // $("#RegisterForm-firstName").addClass("input--error");
       //  errorMessages.push("Username is required.");
        $("<div class='error-messages'>Username is required.</div>").insertAfter("#RegisterForm-firstName");
      }
      /* if ($("#RegisterForm-firstName").next(".error-messages").length) {
            $("#RegisterForm-firstName").next(".error-messages").html("Username is required.");
        } */
        else if (/[^a-zA-Z]/.test(firstName)) {
          $("<div class='error-messages'>Username should only contain letters.</div>").insertAfter("#RegisterForm-firstName");
            $("#RegisterForm-firstName").next(".error-messages").html("Username should only contain letters");
        }
        
       else if (firstName.charAt(0) === " ") {
          $("<div class='error-messages'>First character cannot be a space.</div>").insertAfter("#RegisterForm-firstName");
         // $("#RegisterForm-firstName").next(".error-messages").html("First character cannot be a space");      
        }
       else {
            // If it doesn't exist, create a new element and insert it after #RegisterForm-firstName
            //$("<div class='error-messages'>Username is requiredddddd.</div>").insertAfter("#RegisterForm-firstName");
        }
        
      

      // Check if email is empty
      if (email === "") {
        $("#RegisterForm-email").addClass("input--error");
       errorMessages.push("Email is required.");
         if ($("#RegisterForm-email").next(".error-messages").length) {            
            $("#RegisterForm-email").next(".error-messages").html("Email is required.");
        } else {           
            $("<div class='error-messages'>Email is required.</div>").insertAfter("#RegisterForm-email");
        }
      } else {
        // Check if email format is valid
        var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email)) {
          errorMessages.push("Email format is invalid.");
            if ($("#RegisterForm-email").next(".error-messages").length) {            
            $("#RegisterForm-email").next(".error-messages").html("Email is not validd.");
        } else {           
            $("<div class='error-messages'>Email is not valid.</div>").insertAfter("#RegisterForm-email");
        }
        }
      }

      // Check if password is empty
      if (password === "") {
         $("#RegisterForm-password").addClass("input--error");
          errorMessages.push("Password is required.");
          if ($("#RegisterForm-password").next(".error-messages").length) {            
            $("#RegisterForm-password").next(".error-messages").html("Password is required.");
        }
          if (/\s/.test(password)) {
              $("<div class='error-messages'>Password must not contain space.</div>").insertAfter("#RegisterForm-password");
          }
          else {           
            $("<div class='error-messages'>Password is required.</div>").insertAfter("#RegisterForm-password");
        }
      } else {
        // Check if password length is between 8 and 20 characters
        if (password.length < 8 || password.length > 20) {
             errorMessages.push("Password must be between 8 and 20 characters.");
             if ($("#RegisterForm-password").next(".error-messages").length) {            
            $("#RegisterForm-password").next(".error-messages").html("Password must be between 8 and 20 characters.");
            } else {           
              $("<div class='error-messages'>Password must be between 8 and 20 characters.</div>").insertAfter("#RegisterForm-password");
            }
          // errorMessages.push("Password must be between 8 and 20 characters.");
        }

        if (/\s/.test(password)) {
              $("<div class='error-messages'>Password must not contain space.</div>").insertAfter("#RegisterForm-password");
          }
      }

      // Display error messages if any
      var errorContainer = $(".error-messages");
      if (errorMessages.length > 0) {
      return false;
       
      } else {
        // Add reCAPTCHA token and submit the form
       
        $(this).parents("form").submit();
      }
      return false;
     
    });

   $(".contactbtn").on("click",function(event) {
      
      event.preventDefault();
      $(".error-messages").remove();
       $(".input--error").removeClass("input--error");
      
      var firstName = $("#ContactFormName").val();
      var email = $("#ContactFormEmail").val().trim();
      var phone = $("#ContactFormPhone").val().trim();
	  var subject = $("#ContactFormSubject").val();
	  var msg = $("#ContactFormMessage").val();
      var errorMessages = [];

     
      if (firstName === "") {
         $("#ContactFormName").addClass("input--error");
         errorMessages.push("Name is required.");
       if ($("#ContactFormName").next(".error-messages").length) {
            
            $("#ContactFormName").next(".error-messages").html("Name is required.");
        } else {
            
            $("<div class='error-messages'>Name is required.</div>").insertAfter("#ContactFormName");
        }
        
      }
    if(firstName.charAt(0)==" "){
           $("<div class='error-messages'>First letter must not contain space.</div>").insertAfter("#ContactFormName");
       }
      
      if (email === "") {
        $("#ContactFormEmail").addClass("input--error");
       errorMessages.push("Email is required.");
         if ($("#ContactFormEmail").next(".error-messages").length) {            
            $("#ContactFormEmail").next(".error-messages").html("Email is required.");
        } else {           
            $("<div class='error-messages'>Email is required.</div>").insertAfter("#ContactFormEmail");
        }
      } else {
        
        var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email)) {
          errorMessages.push("Email format is invalid.");
            if ($("#ContactFormEmail").next(".error-messages").length) {            
            $("#ContactFormEmail").next(".error-messages").html("Email is not valid.");
        } else {           
            $("<div class='error-messages'>Email is not valid.</div>").insertAfter("#ContactFormEmail");
        }
        }
      }
	  
	    if (subject === "") {
         $("#ContactFormSubject").addClass("input--error");
         errorMessages.push("Subject is required.");
       if ($("#ContactFormSubject").next(".error-messages").length) {
            $("#ContactFormSubject").next(".error-messages").html("Subject is required.");
        } 
       
       else {
            
            $("<div class='error-messages'>Subject is required.</div>").insertAfter("#ContactFormSubject");
        }
        
      }

     if(subject.charAt(0)==" "){
           $("<div class='error-messages'>First letter must not contain space.</div>").insertAfter("#ContactFormSubject");
       }
	  
	    if (msg === "") {
         $("#ContactFormMessage").addClass("input--error");
         errorMessages.push("Message is required.");
       if ($("#ContactFormMessage").next(".error-messages").length) {
            
            $("#ContactFormMessage").next(".error-messages").html("Message is required.");
        } else {
            
            $("<div class='error-messages'>Message is required.</div>").insertAfter("#ContactFormMessage");
        }
        
      }
      if(msg.charAt(0)==" "){
           $("<div class='error-messages'>First letter must not contain space.</div>").insertAfter("#ContactFormMessage");
       }

     
      if (phone === "") {
         $("#ContactFormPhone").addClass("input--error");
          errorMessages.push("Phone number is required.");
          if ($("#ContactFormPhone").next(".error-messages").length) {            
            $("#ContactFormPhone").next(".error-messages").html("Phone number is required.");
        } else {           
            $("<div class='error-messages'>Phone number is required.</div>").insertAfter("#ContactFormPhone");
        }
      } else {
        
        if (phone.length < 10 || phone.length > 10) {
             errorMessages.push("Enter a 10-digit number only.");
             if ($("#ContactFormPhone").next(".error-messages").length) {            
            $("#ContactFormPhone").next(".error-messages").html("PEnter a 10-digit number only.");
            } else {           
              $("<div class='error-messages'>Enter a 10-digit number only.</div>").insertAfter("#ContactFormPhone");
            }
          
        }

        if (/^0+$/.test(phone)) {
          $("<div class='error-messages'>Phonenumber must not contain all zeros.</div>").insertAfter("#ContactFormPhone");
        }
      }

      
      var errorContainer = $(".error-messages");
      if (errorMessages.length > 0) {
      return false;
       
      } else {
               
        $(this).parents("form").submit();
      }
      return false;
     
    });

//// validation for login form
  $(".submitloginform").on("click",function(event) {
      // Prevent the form from submitting
      event.preventDefault();
      $(".error-messages").remove();
       $(".input--error").removeClass("input--error");
      // Validate inputs
      
      var email = $("#CustomerEmail").val().trim();
      var password = $("#CustomerPassword").val().trim();
      var errorMessages = []; 
      // Check if email is empty
      if (email === "") {
        $("#CustomerEmail").addClass("input--error");
       errorMessages.push("Email is required.");
         if ($("#CustomerEmail").next(".error-messages").length) {            
            $("#CustomerEmail").next(".error-messages").html("Email is required.");
        } else {           
            $("<div class='error-messages'>Email is required.</div>").insertAfter("#CustomerEmail");
        }
      } else {
        // Check if email format is valid
        var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email)) {
          $("#CustomerEmail").addClass("input--error");
          errorMessages.push("Email format is invalid.");
            if ($("#CustomerEmail").next(".error-messages").length) {            
            $("#CustomerEmail").next(".error-messages").html("Email is not validd.");
        } else {           
            $("<div class='error-messages'>Email is not valid.</div>").insertAfter("#CustomerEmail");
        }
        }
      }

      // Check if password is empty
      if (password === "") {
         $("#CustomerPassword").addClass("input--error");
          errorMessages.push("Password is required.");
          if ($("#CustomerPassword").next(".error-messages").length) {            
            $("#CustomerPassword").next(".error-messages").html("Password is required.");
        } else {           
            $("<div class='error-messages'>Password is required.</div>").insertAfter("#CustomerPassword");
        }
      }  

      // Display error messages if any
      var errorContainer = $(".error-messages");
      if (errorMessages.length > 0) {
      return false;
       
      } else {
        // Add reCAPTCHA token and submit the form
       
        $(this).parents("form").submit();
      }
      return false;
     
    });


$(".swatchLbl").click(function () {   
   setTimeout(function () {
     var variantId =  $("#ProductSelect-"+product_template_var).val();
      
    // Find the variant with the specified ID
    var variant = $.grep(productData.variants, function (v) {
        return v.id === parseInt(variantId);
    })[0];
   // Check if the variant is found
    if (variant) {
        // Get the featured_image of the variant
        var vValue = variant.featured_image.src.match(/v=(\d+)/)[1];;
        // Log or use the featured_image as needed
        var aElements = document.querySelectorAll('a.pr_photo');
        // Iterate through each <a> element
        for (var i = 0; i < aElements.length; i++) {
            var hrefValue = aElements[i].getAttribute('href');

            // Check if hrefValue contains v= followed by the same value as in data-bgset
            if (hrefValue && hrefValue.includes('v=' + vValue)) {
                aElements[i].classList.remove('hidethis');
            } else {
                aElements[i].classList.add('hidethis');
            }
        }
    } else {
        console.log("Variant not found");
    }
   },200);
});
// by nitin jamdhade on 23 jan 2024 Ends



  document.addEventListener('DOMContentLoaded', function() {
    var rememberMeCheckbox = document.getElementById('remember_me');
    var loginForm = document.querySelector('form[action="/account/login"]');
   if (loginForm && rememberMeCheckbox) {
    loginForm.addEventListener('submit', function(event) {
      if (rememberMeCheckbox.checked) {
        // Set a cookie or use local storage to remember the user's choice
        // Example using localStorage:
        localStorage.setItem('remember', 'true');
      }
    });

    // Optionally, pre-check the "Remember Me" checkbox based on previous choice
    var rememberMeStored = localStorage.getItem('remember');
    if (rememberMeStored === 'true') {
      rememberMeCheckbox.checked = true;
    }
   }
      function togglePassword(inputId) {
    var passwordInput = document.getElementById(inputId);
    var toggleButton = document.querySelector('[onclick="togglePassword(\'' + inputId + '\')"]');

    if (passwordInput.type === 'password') {
      passwordInput.type = 'text';
      toggleButton.textContent = 'Hide';
    } else {
      passwordInput.type = 'password';
      toggleButton.textContent = 'Show';
    }
  }

  });

function togglePassword(inputId) {
    var passwordInput = document.getElementById(inputId);

    if (passwordInput) {
        var toggleButton = $('[data-target="' + inputId + '"]');

        if (toggleButton.length > 0) {
            if (passwordInput.type === 'password') {
                passwordInput.type = 'text';
                toggleButton.html('<svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14" fill="none"><path d="M18.4481 7.04001L18.5579 6.81818L18.4481 6.59635C17.6501 4.9843 16.4928 3.69841 14.9823 2.74734C13.4697 1.79496 11.8052 1.31818 10 1.31818C8.19479 1.31818 6.53028 1.79496 5.01768 2.74734C3.50716 3.69841 2.34995 4.9843 1.5519 6.59635L1.44209 6.81818L1.5519 7.04001C2.34995 8.65206 3.50716 9.93796 5.01768 10.889C6.53028 11.8414 8.19479 12.3182 10 12.3182C11.8052 12.3182 13.4697 11.8414 14.9823 10.889C16.4928 9.93796 17.6501 8.65206 18.4481 7.04001ZM12.5442 9.36236C11.8436 10.063 11.0053 10.4091 10 10.4091C8.99473 10.4091 8.15645 10.063 7.45583 9.36236C6.7552 8.66173 6.40909 7.82345 6.40909 6.81818C6.40909 5.81291 6.7552 4.97463 7.45583 4.27401C8.15645 3.57339 8.99473 3.22727 10 3.22727C11.0053 3.22727 11.8436 3.57339 12.5442 4.27401C13.2448 4.97463 13.5909 5.81291 13.5909 6.81818C13.5909 7.82345 13.2448 8.66173 12.5442 9.36236ZM7.90781 8.91037C8.47992 9.48248 9.18709 9.77273 10 9.77273C10.8129 9.77273 11.5201 9.48248 12.0922 8.91037C12.6643 8.33827 12.9545 7.63109 12.9545 6.81818C12.9545 6.00527 12.6643 5.2981 12.0922 4.72599C11.5201 4.15389 10.8129 3.86364 10 3.86364C9.18709 3.86364 8.47992 4.15389 7.90781 4.72599C7.33571 5.2981 7.04545 6.00527 7.04545 6.81818C7.04545 7.63109 7.33571 8.33827 7.90781 8.91037ZM10 13.1364C7.88736 13.1364 5.9702 12.5486 4.23546 11.3705C2.55555 10.2295 1.32535 8.71582 0.539269 6.81818C1.32535 4.92054 2.55555 3.40684 4.23546 2.2659C5.9702 1.08772 7.88736 0.5 10 0.5C12.1126 0.5 14.0298 1.08772 15.7645 2.2659C17.4445 3.40684 18.6747 4.92054 19.4607 6.81818C18.6747 8.71582 17.4445 10.2295 15.7645 11.3705C14.0298 12.5486 12.1126 13.1364 10 13.1364Z" fill="#1C1B1F" stroke="black"/></svg>');
            } else {
                passwordInput.type = 'password';
                toggleButton.html('<svg xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17" fill="none"><path d="M12.8545 8.59091L11.6682 7.40455C11.7909 6.76364 11.6068 6.16364 11.1159 5.60455C10.625 5.04545 9.99091 4.82727 9.21364 4.95L8.02727 3.76364C8.25909 3.65455 8.49432 3.57273 8.73295 3.51818C8.97159 3.46364 9.22727 3.43636 9.5 3.43636C10.5227 3.43636 11.392 3.79432 12.108 4.51023C12.8239 5.22614 13.1818 6.09546 13.1818 7.11818C13.1818 7.39091 13.1545 7.64659 13.1 7.88523C13.0455 8.12386 12.9636 8.35909 12.8545 8.59091ZM15.4727 11.1682L14.2864 10.0227C14.8045 9.62727 15.2648 9.19432 15.667 8.72386C16.0693 8.25341 16.4136 7.71818 16.7 7.11818C16.0182 5.74091 15.0398 4.64659 13.7648 3.83523C12.4898 3.02386 11.0682 2.61818 9.5 2.61818C9.10455 2.61818 8.71591 2.64545 8.33409 2.7C7.95227 2.75455 7.57727 2.83636 7.20909 2.94545L5.94091 1.67727C6.5 1.44545 7.07273 1.27159 7.65909 1.15568C8.24545 1.03977 8.85909 0.981818 9.5 0.981818C11.5591 0.981818 13.3932 1.55114 15.0023 2.68977C16.6114 3.82841 17.7773 5.30455 18.5 7.11818C18.1864 7.92273 17.7739 8.66932 17.2625 9.35795C16.7511 10.0466 16.1545 10.65 15.4727 11.1682ZM15.8818 16.2L12.4455 12.8045C11.9682 12.9545 11.4875 13.067 11.0034 13.142C10.5193 13.217 10.0182 13.2545 9.5 13.2545C7.44091 13.2545 5.60682 12.6852 3.99773 11.5466C2.38864 10.408 1.22273 8.93182 0.5 7.11818C0.786364 6.39545 1.14773 5.72386 1.58409 5.10341C2.02045 4.48295 2.51818 3.92727 3.07727 3.43636L0.827273 1.14545L1.97273 0L17.0273 15.0545L15.8818 16.2ZM4.22273 4.58182C3.82727 4.93636 3.46591 5.325 3.13864 5.74773C2.81136 6.17045 2.53182 6.62727 2.3 7.11818C2.98182 8.49545 3.96023 9.58977 5.23523 10.4011C6.51023 11.2125 7.93182 11.6182 9.5 11.6182C9.77273 11.6182 10.0386 11.6011 10.2977 11.567C10.5568 11.533 10.8227 11.4955 11.0955 11.4545L10.3591 10.6773C10.2091 10.7182 10.0659 10.7489 9.92955 10.7693C9.79318 10.7898 9.65 10.8 9.5 10.8C8.47727 10.8 7.60795 10.442 6.89205 9.72614C6.17614 9.01023 5.81818 8.14091 5.81818 7.11818C5.81818 6.96818 5.82841 6.825 5.84886 6.68864C5.86932 6.55227 5.9 6.40909 5.94091 6.25909L4.22273 4.58182Z" fill="#1C1B1F"/></svg>');
                
            }
        }
    }
}

$(document).ready(function() {
  var quantityInput = $("#quantity");

  quantityInput.on("input", function() {
    var inputValue = $(this).val();

    // Remove the letter 'e' if found
    inputValue = inputValue.replace(/e/i, '');

    // Update the input value
    $(this).val(inputValue);
  });
});


// FAQ Dropdown Start - 18-07-2024

$(document).ready(function() {
    $('.accordion-header').click(function() {
      
      $(this).parent().toggleClass('active');
      
      $(this).next('.accordion-content').find('.accordionContentBox').slideToggle();
  
      $(this).parent().siblings('.accordion-item').removeClass('active').find('.accordionContentBox').slideUp();
    });
  });
// FAQ Dropdown End   - 18-07-2024


